import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Container, Stack, Typography, Button } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import PageBanner from "./components/pageBanner";
import Panel from "./components/whitePanel";
import Copyright from "../Copyright";
import "./orderDetail.css";

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <Box className="NewOrder">
            <PageBanner title="PARCEL STATUS" subheading="Track Not Found" />
            <Container maxWidth="lg">
                <div id="pageContent" style={{ marginTop: "-48px" }}>
                    <Panel>
                        <Stack alignItems="center" spacing={2} sx={{ py: 6, textAlign: "center" }}>
                            <SearchOffIcon sx={{ fontSize: 56, color: "text.disabled" }} />
                            <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                We couldn't find that shipment
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
                                The tracking number, account, or reference you searched for doesn't match any order in
                                our system.
                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => navigate("/tracking")}
                                sx={{ mt: 1 }}
                            >
                                Track Another Shipment
                            </Button>
                        </Stack>
                    </Panel>
                </div>
            </Container>
            <footer>
                <Copyright />
            </footer>
        </Box>
    );
}
